import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import type { CmsApiPage } from '#/modules/cms/api/types/CmsApiPage';

export function getCmsContentOgImage(
  page: CmsApiPage,
): ApiFilestackImageData | null {
  if (page.thumbnail) return page.thumbnail;
  if (page.headerImage) return page.headerImage;

  for (const block of page.contentBlocks) {
    if (block.type === 'IMAGE') return block.data.image;

    if (block.type === 'SPLIT_CONTENT') {
      for (const section of block.data.sections) {
        if (section.type === 'IMAGE') return section.data.image;

        if (section.type === 'VIDEO' && section.data.image)
          return section.data.image;
      }
    }

    if ('image' in block.data) return block.data.image;
  }

  if (page.subsite?.placeholderImages?.length)
    return page.subsite.placeholderImages[0];

  return null;
}
